import styles from "../css/home.module.css";

import logo from '../assets/Monochrome.png';
import '../css/login.css';

export default function Login() {
  return (
    <main className="bg">
      <div></div>
      <div className={styles.logocontainer}>
        <img className="" src={logo} alt="Ikigai Logo" width={170} />
        <div className={`${styles.manropefont} mt-5`}>EMPLOYEE</div>
        <div className={styles.manropefont}>HANDBOOKS</div>
      </div>
    <div className="btnWrap">
      <a
        className="loginBtn loginBtn:hover loginBtn:focus"
        href={import.meta.env.VITE_LoginURL}
      >
        <svg
          className="w-4 h-4 me-2"
          style={{width: 16,height: 16,marginRight: 8}}
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="#e5fb05"
          viewBox="0 0 18 19"
        >
          <path
            fillRule="evenodd"
            d="M8.842 18.083a8.8 8.8 0 0 1-8.65-8.948 8.841 8.841 0 0 1 8.8-8.652h.153a8.464 8.464 0 0 1 5.7 2.257l-2.193 2.038A5.27 5.27 0 0 0 9.09 3.4a5.882 5.882 0 0 0-.2 11.76h.124a5.091 5.091 0 0 0 5.248-4.057L14.3 11H9V8h8.34c.066.543.095 1.09.088 1.636-.086 5.053-3.463 8.449-8.4 8.449l-.186-.002Z"
            clipRule="evenodd"
          />
        </svg>
        Login with IKG Email
      
      </a>
    </div>
    </main>
  );
}
